module.exports = __webpack_public_path__ + "img/MGH-Yokohama-1-2440x1172.ff232ce5.jpg";